import classNames from "classnames";
import React from "react";
import { getStyles } from "../../../assets/js/utils/functions";
import { FrontPagesNavigation } from "../commons";
import ContentScroller from "../commons/content-scroller";

const WhyCatlogHeader = () => {
  return (
    <header className="front-header front-header--why-catlog section-spacing">
      <FrontPagesNavigation />
      <div className="body-padding">
        <div className="mt-8 sm:11.25 md:mt-15 flex flex-col items-center container">
          <div className="flex flex-col items-center max-w-full">
            <h1 className={classNames("font-light text-center text-black mt-5 heading-two")}>
              <div className="words-line">
                <span className="anim-word-up inline-block">Why</span>{" "}
                <span className="anim-word-up inline-block" style={getStyles({ "--delay": "0.15s" })}>
                  do
                </span>{" "}
                <span className="anim-word-up inline-block" style={getStyles({ "--delay": "0.3s" })}>
                  thousands
                </span>{" "}
                <span className="anim-word-up inline-block" style={getStyles({ "--delay": "0.45s" })}>
                  of
                </span>{" "}
              </div>{" "}
              <div className="words-line font-bold text-primary-500">
                <span className="anim-word-up inline-block !leading-tight" style={getStyles({ "--delay": "0.6s" })}>
                  businesses use Catlog?
                </span>
              </div>{" "}
            </h1>
            <p
              className={classNames(
                "text-black-secondary text-center follow-text font-normal max-w-[360px] sm:max-w-[560px] lg:max-w-[750px]  xl:max-w-[800px] mt-3.75 sm:mt-5 slide-text-in hero-text"
              )}
              style={getStyles({ "--delay": "0.6s" })}
            >
              At Catlog we understand that your business has endless possibilities on social media - and we want to help
              you harness that.
            </p>
            <div className="anim-fade-up" style={getStyles({ "--delay": "0.8s" })}>
              <ContentScroller list={extras} spacing="sm" whiteCards />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

const extras = [
  [
    {
      label: "All your products in one link",
      emoji: "🔗",
    },
    {
      label: "Automatic SEO",
      emoji: "🔎",
    },
    {
      label: "Free business bank account",
      emoji: "🏦",
    },
    {
      label: "Get paid with different methods",
      emoji: "💳",
    },
    {
      label: "Manage Orders",
      emoji: "🛍",
    },
    {
      label: "Manage Customers",
      emoji: "🙎🏽‍♂️",
    },
    {
      label: "Custom store links",
      emoji: " 🖇",
    },
    {
      label: "Product options",
      emoji: "👠",
    },
  ],
  [
    {
      label: "Create discounts",
      emoji: "🎁",
    },
    {
      label: "Create coupons",
      emoji: "🎟",
    },
    {
      label: "Upload multiple products at once",
      emoji: "📦",
    },
    {
      label: "Create invoice links",
      emoji: "📃",
    },
    {
      label: "Get orders & delivery info in one message",
      emoji: "📜",
    },
    {
      label: "Multiple WhatsApp numbers",
      emoji: "💬",
    },
    {
      label: "Get customers from Twitter",
      emoji: "🐦",
    },
    {
      label: "Set prices for locations you deliver to",
      emoji: "🚚",
    },
  ],
  [
    {
      label: "Links to single products",
      emoji: "👖",
    },
    {
      label: "Manage product quantities",
      emoji: "🧳",
    },
    {
      label: "Collect payments on WhatsApp",
      emoji: "💸",
    },
    {
      label: "Add multiple store managers",
      emoji: "🤵🏽",
    },
    {
      label: "Free withdrawals",
      emoji: "🆓",
    },
    {
      label: "Automatic receipts",
      emoji: "🧾",
    },
    {
      label: "Manage multiple stores from one account",
      emoji: "🛒",
    },
    {
      label: "Organize your products into categories",
      emoji: "🗂",
    },
  ],
  [
    {
      label: "Link to help customers track their orders",
      emoji: "🔗",
    },
    {
      label: "See best-performing customers",
      emoji: "🧑🏾‍🚀",
    },
    {
      label: "Create PDF invoices",
      emoji: "📃",
    },
    {
      label: "Fast & Cheap transactions",
      emoji: "⚡️",
    },
    {
      label: "Link social media profiles",
      emoji: "🎈",
    },
    {
      label: "Marketing & campaign tools - coming soon",
      emoji: "💌",
    },
    {
      label: "Deliver to customers without hassle - coming soon",
      emoji: "🚚",
    },
    {
      label: "Set opening & closing hours",
      emoji: "⏰",
    },
  ],
];

export default WhyCatlogHeader;
